export default __webpack_public_path__ + "739239d96a9acbd41935cece881fe1b2.svg";